
// MIXITUP

var containerEl = document.querySelector('.mix-container');
var mixer = mixitup(containerEl, {
    multifilter: {
        enable: true
    },
    animation: {
        effects: 'fade translateZ(-100px)'
    }
});
